import download from 'downloadjs';
import { removeUser } from '../actions/user.js';
import store from '../index.js';
import { showErrorNotify, showSuccessNotify, showWarningNotify } from '../utils/Notiffication/index.js';

export const formBody = (data = {}) =>
  Object.keys(data)
    .filter((key) => data[key] !== null)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
    .join('&');


export const mainFetch = async ({ url, method, data, ...params }) => {

  const state = store.getState();
  const notify = { success: true, error: true, msg: '', ...(params.notify || {}) }
  const signal = params.signal
  const options = params.options || {}

  let body

  if (options.uploadFiles) {
    const formData = new FormData();

    Object.entries(data).forEach(([key, value]) => {

      console.log(key, value)
      if (key === 'files') {
        value?.forEach((file, i) => {
          formData.append(`file${i + 1}`, file);
        });
      } else
        formData.append(key, value);
    })

    body = formData
  } else {
    body = JSON.stringify(data)
  }

  const settings = {
    method,
    ...(method !== 'GET' && { body }),
    ...(signal && { signal }),
    credentials: 'include',
    headers: {
      'X-App-Version': state.version,
      'Accept': 'application/json',
      ...(!options.uploadFiles && { 'Content-Type': 'application/json' }),
    },
  };

  return await fetch(
    `${process.env.REACT_APP_API_BACKEND}${url}${method === 'GET' && data ? `?${formBody(data)}` : ''}`,
    settings,
  )
    .then(async (response) => {

      if (!response.ok)
        throw { status: response.status, message: await response.json().then(r => r.message) };

      if (options.download) {
        const headerParts = response.headers.get('content-disposition').replaceAll('"', '').split(';')
        const filename = decodeURIComponent(headerParts[1].split('=')[1])
        return download(await response.blob(), filename);
      }

      if (options.pdf) {
        return btoa(new Uint8Array(await response.arrayBuffer()).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      }

      const res = await response.json()

      if (res.warning) {
        showWarningNotify(res.warning);
      } else {
        if (notify.success) showSuccessNotify(notify.msg || 'Успешно')
      }

      return res;
    })
    .catch(async (error) => {
      if (error.name === 'AbortError') {
        throw error
      }

      if (error.status === 401) {
        showErrorNotify(error.message);
        store.dispatch(removeUser());
        console.log('redirect to login page');
        window.location.assign('/login');
      }

      if (error.status === 426) {
        showErrorNotify('Обновите станицу F5');
        alert('Приложение обновлено. Страница будет обновлена')
        // console.log('redirect to login page');
        window.location.reload(true);
        return 

      }

      if (error.status >= 500) {
        showErrorNotify(`Ошибка сервера ${error.status}: ${error.message}. Обратитесь к администратору`);
        throw error;
      }

      if (error.status === 403) {
        showErrorNotify(error.message);
        throw error;
      }


      if (notify.error) showErrorNotify(`Запрос не выполнен: ${error.message}`)
      throw error;
    });
};

export const formUrl = (api) => `${process.env.REACT_APP_API_BACKEND}${api}`;

// export default doRequest;
